import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SourcePathPipe } from './source-path-pipe';
import { ToastIconPipe } from './toast-icon-pipe';

@NgModule({
  declarations: [SourcePathPipe, ToastIconPipe],
  imports: [CommonModule],
  exports: [SourcePathPipe, ToastIconPipe],
})
export class MainPipe {
  public static forRoot(): any {
    return {
      ngModule: MainPipe,
      providers: [],
    };
  }
}
